"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineChart = exports.DateRange = void 0;
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var DateRangeModal_1 = __importDefault(require("./DateRangeModal"));
// import DateRangeSelect from "./DateRangeSelect";
var DateRange;
(function (DateRange) {
  DateRange["SEVEN"] = "Last 7 days";
  DateRange["FOURTEEN"] = "Last 14 days";
  DateRange["TWENTYEIGHT"] = "Last 28 days";
  DateRange["CUSTOM"] = "Custom Date Range";
})(DateRange = exports.DateRange || (exports.DateRange = {}));
var LineChart = /** @class */function (_super) {
  __extends(LineChart, _super);
  function LineChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      apexModule: null,
      dateRangeModalVisible: false,
      startTime: (0, moment_1.default)().startOf("day").format("HH:00"),
      endTime: (0, moment_1.default)().endOf("day").format("HH:00"),
      timeRangeError: "",
      dateRangeError: ""
    };
    _this.componentDidMount = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var reactApexChart;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, Promise.resolve().then(function () {
                return __importStar(require("react-apexcharts"));
              })];
            case 1:
              reactApexChart = _a.sent();
              this.setState({
                apexModule: reactApexChart.default
              });
              return [2 /*return*/];
          }
        });
      });
    };

    _this.handleOnChange = function (id, key) {
      if (!Array.isArray(key)) {
        if (id) {
          _this.props.onChange(key);
          if (key === "CUSTOM") {
            _this.handleDateRangeModalVisible(true);
          }
        }
      }
      _this.handleGraphData();
    };
    _this.handleDateRangeModalVisible = function (visible) {
      _this.setState({
        dateRangeModalVisible: visible,
        dateRangeError: ""
      });
    };
    _this.handleDateRangeSubmit = function () {
      if ((0, moment_1.default)(_this.props.customDate.startDate).isAfter((0, moment_1.default)(_this.props.customDate.endDate))) {
        _this.setState({
          dateRangeError: "Please select a proper date range"
        });
      } else if ((0, moment_1.default)(_this.props.customDate.startDate).format("DD/MM/YYYY") === (0, moment_1.default)(_this.props.customDate.endDate).format("DD/MM/YYYY") && !(0, moment_1.default)(_this.state.endTime, "HH:mm").isAfter((0, moment_1.default)(_this.state.startTime, "HH:mm"))) {
        _this.setState({
          timeRangeError: "Please select a proper time range"
        });
      } else {
        _this.setState({
          dateRangeError: "",
          timeRangeError: ""
        }, function () {
          return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
              this.handleDateRangeModalVisible(false);
              return [2 /*return*/];
            });
          });
        });
      }
    };

    _this.handleGraphData = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var dateRange;
        return __generator(this, function (_a) {
          dateRange = {
            startDate: new Date(),
            endDate: new Date()
          };
          if (this.props.dateRange === "SEVEN") {
            dateRange = {
              endDate: (0, moment_1.default)().toDate(),
              startDate: (0, moment_1.default)().subtract(7, "days").toDate()
            };
          } else if (this.props.dateRange === "FOURTEEN") {
            dateRange = {
              endDate: (0, moment_1.default)().toDate(),
              startDate: (0, moment_1.default)().subtract(14, "days").toDate()
            };
          } else if (this.props.dateRange === "TWENTYEIGHT") {
            dateRange = {
              endDate: (0, moment_1.default)().toDate(),
              startDate: (0, moment_1.default)().subtract(28, "days").toDate()
            };
          }
          this.props.setCustomDate(dateRange);
          return [2 /*return*/];
        });
      });
    };

    _this.renderDateRangeOptions = function () {
      var dateRangeOptions = [];
      Object.keys(DateRange).map(function (eachDateRangeKey) {
        dateRangeOptions.push({
          key: eachDateRangeKey,
          title: DateRange[eachDateRangeKey]
        });
        return null;
      });
      return dateRangeOptions;
    };
    return _this;
  }
  LineChart.prototype.render = function () {
    var APEXModule = this.state.apexModule;
    var defaultClass = "flex flex-col justify-center bg-white overflow-hidden shadow rounded-lg pl-4 pb-3 w-full ";
    if (this.props.containerStyle) defaultClass += this.props.containerStyle;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(DateRangeModal_1.default, {
      title: "Create Date",
      open: this.state.dateRangeModalVisible,
      startDate: this.props.customDate.startDate,
      endDate: this.props.customDate.endDate,
      dateRangeError: this.state.dateRangeError,
      onChange: this.props.onChangeCustom,
      onClick: this.handleDateRangeSubmit,
      onClose: this.handleDateRangeModalVisible.bind(this, false)
    }), react_1.default.createElement("div", {
      className: defaultClass
    }, react_1.default.createElement("div", {
      className: "ml-2 pr-5 my-4 flex flex-row items-center"
    }, react_1.default.createElement("div", {
      className: "flex-1"
    }, react_1.default.createElement("h3", {
      className: "text-lg truncate font-medium"
    }, this.props.title)), this.props.tool), react_1.default.createElement("div", {
      className: "w-11/12"
    }, APEXModule && react_1.default.createElement(APEXModule, {
      height: this.props.chartHeight ? this.props.chartHeight : 300,
      options: {
        chart: {
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: this.props.showToolbar
          }
        },
        colors: this.props.lineColors,
        dataLabels: {
          enabled: this.props.showDataLabels
        },
        stroke: {
          curve: "smooth"
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: this.props.categories,
          title: {
            text: this.props.xaxisTitle,
            style: {
              fontSize: "11",
              fontWeight: "bold"
            }
          }
        },
        yaxis: {
          title: {
            text: this.props.yaxisTitle,
            style: {
              fontSize: "11",
              fontWeight: "bold"
            }
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      },
      series: this.props.multiLineSeries ? this.props.multiLineSeries : [{
        name: this.props.seriesName,
        data: this.props.seriesData
      }],
      type: "line"
    }))));
  };
  return LineChart;
}(react_1.Component);
exports.LineChart = LineChart;